<template>
  <v-btn
    class="py-6 d-flex justify-start border-radius"
    @click="onClick"
    color="grey-lighten-4"
    elevation="3"
  >
    <r-img
      :src="KindTypeIcon.linkedinPost"
      width="30"
      height="30"
      class="mr-2 flex-grow-0"
    />
    {{ $t('buttons.social-media.connect-linkedin') }}
  </v-btn>
</template>

<script>
import { KindTypeIcon } from '../../enums/KindType'

export default {
  props: {
    connect: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      KindTypeIcon,
    }
  },
  emits: ['featureEnabled'],
  methods: {
    async onClick() {
      const result = await this.connect()
      if (result === false) this.$emit('featureEnabled', false)
    },
  },
}
</script>
<style scoped>
.border-radius {
  border-radius: 4px !important;
}
</style>
